export const CardList = [
  {
    'cardid': 'C01',
    'cardnumber': 'C1',
    'image': require('@/assets/images/card/C1.jpg'),
    'name': 'Ace of Cups',
    'subtitle':'โลกเหวี่ยงคนที่ใช่มาล้าว',
    'detail': "ไพ่หนึ่งถ้วยบ่งบอกว่าคุณจะเจอความรักครั้งใหม่ที่มีโอกาสพัฒนาไปในทิศทางที่ดีขึ้น ใครได้ไพ่ใบนี้จะมีความแซ่บ น่ากิน และดึงดูดเพศตรงข้ามมาก ดูแลตัวเองให้สดชื่นทุกวันแล้วรอความรักที่กำลังจะมาได้เลย"
  },
  {
    'cardid': 'C02',
    'cardnumber': 'C2',
    'image': require('@/assets/images/card/C2.jpg'),
    'name': 'Two of Cups',
    'subtitle': 'ลงตัวแบบมงลง',
    'detail': "ไพ่ใบนี้บ่งบอกว่าคุณมีโอกาสที่จะเจอรักโรแมนติกลงตัว เข้ากันได้เนียนมาก และเมื่ออยู่ด้วยกันจะเป็นความรักที่ดีหวานชื่นรื่นรมย์อย่างมาก แต่ถ้าคุณโสด คุณอาจจะได้ลิ้มลองรสชาติใหม่ๆ ของความรักจากคนใกล้ตัวก็เป็นได้นะ"
  },
  {
    'cardid': 'C03',
    'cardnumber': 'C3',
    'image': require('@/assets/images/card/C3.jpg'),
    'name': 'Three of Cups',
    'subtitle': 'รักดีๆ รออยู่ในที่ใหม่ๆ ',
    'detail': "คนโสดมีเกณฑ์จะได้พบรักจากงานปาร์ตี้หรืองานสังสรรค์ต่างๆ ซึ่งคุณมีโอกาสเจอความรักที่แฮปปี้ แต่หากคุณมีคู่แล้วนั้นอาจมีอารมณ์อยากเปลี่ยนบรรยากาศตลอดเวลา เพื่อให้ได้ลิ้มรสชาติใหม่ๆ แต่ไม่ว่าจะรสไหนก็หอมเนียนนุ่ม ละมุนเหมือนความรักของคุณนั่นแหละ"
  },
  {
    'cardid': 'C04',
    'cardnumber': 'C4',
    'image': require('@/assets/images/card/C4.jpg'),
    'name': 'Four of Cups',
    'subtitle': 'เติมรสชาติให้ความรักหน่อย',
    'detail': "คุณอาจเจอกับความเบื่อหน่าย ความรู้สึกที่ไม่ดี และหากคุณโสดก็อาจต้องโสดไปก่อน เพราะช่วงนี้ยังไม่ค่อยเหมาะกับการที่จะสร้างสัมพันธ์ใดๆ กับใคร และหากคุณมีคู่อาจเกิดการทะเลาะเบาะแว้ง ไม่ค่อยลงตัว และอาจทำให้เลิกรากันได้ เสริมดวงรักให้กลับมาดีโดยหมั่นดูแลมอบสิ่งดีๆ ให้กัน รักไม่จืดชืดถ้าหมั่นเติมความหวานทุกวัน"
  },
  {
    'cardid': 'C05',
    'cardnumber': 'C5',
    'image': require('@/assets/images/card/C5.jpg'),
    'name': 'Five of Cups',
    'subtitle': 'รักตัวเองเข้าไว้นะ',
    'detail': "คุณอาจพบความเศร้าโศกเสียใจ หรืออาจต้องเลิกรากับใครสักคนโดยไม่ตั้งใจ ที่สำคัญคุณอาจเจอปัญหาเรื่องมือที่สาม ดังนั้นช่วงนี้พยายามอย่าเครียด หากิจกรรมทำร่วมกัน และทำบุญเสริมดวงไหว้พระแม่อุมาเทวี แต่ถ้าต้องเลิกจริงๆ อย่าปล่อยให้ออร่าดับ กลับมารักดูแลตัวเองให้สดใส มีสีสัน มีรสชาติ เชื่อแม่"
  },
  {
    'cardid': 'C06',
    'cardnumber': 'C6',
    'image': require('@/assets/images/card/C6.jpg'),
    'name': 'Six of Cups',
    'subtitle': 'ต้องสมูธแต่หนักแน่น',
    'detail': "ไพ่บ่งบอกว่าคุณจะประสบความสำเร็จในเรื่องความรัก ความอบอุ่นในครอบครัว หรือการครองคู่อย่างมีความสุข บางคู่อาจถึงขั้นแต่งงานมีทายาท แต่ก็ยังมีเรื่องที่ต้องระวังคือความโลกส่วนตัวสูงของทั้งคู่ ซึ่งถ้ามีเยอะเกินไปอาจส่งผลเสียได้เช่นกัน"
  },
  {
    'cardid': 'C07',
    'cardnumber': 'C7',
    'image': require('@/assets/images/card/C7.jpg'),
    'name': 'Seven of Cups',
    'subtitle': 'ใช้สติแล้วจะไม่ sad',
    'detail': "ช่วงนี้คุณอาจเจอความรักที่ค่อนข้างเพ้อฝันและอยู่ในโลกมโน มองอะไรก็สวยไปหมด และอาจทำให้คุณเผลอมีใจให้คนมีเจ้าของหรือรักเขาฝ่ายเดียว ช่วงนี้ถ้าใครเข้ามาในชีวิต เขาอาจแค่มาบริหารเสน่ห์ คุณต้องอย่าเผลอใจ เพราะที่คิดว่าหอมหวาน อาจกลายเป็นความท็อกซิก แม่แนะนำมองหาอะไรเฮลท์ตี้ๆ ดีต่อใจให้ตัวเองดีกว่านะ"
  },
  {
    'cardid': 'C08',
    'cardnumber': 'C8',
    'image': require('@/assets/images/card/C8.jpg'),
    'name': 'Eight of Cups',
    'subtitle': 'เปลี่ยนตัวเองเป็นสายซอฟท์',
    'detail': "ไพ่ใบนี้บ่งบอกว่าคุณอาจจะเจอปัญหาความรักไม่เป็นไปดั่งหวัง และให้ระวังการทะเลาะเพราะคำพูดที่ตรงไปตรงมาของคุณ หรือพูดไม่คิด จะส่งผลให้ความรักที่มีพังได้ ลองฝึกพูดหวานๆ นุ่มๆ จะช่วยเสริมให้คุณดูน่ารักน่าคุยด้วย และส่งผลดีกับตัวคุณ"
  },
  {
    'cardid': 'C09',
    'cardnumber': 'C9',
    'image': require('@/assets/images/card/C9.jpg'),
    'name': 'Nine of Cups',
    'subtitle': 'คนคลั่งรักคืนวงการ',
    'detail': "ไพ่ใบนี้บ่งบอกว่าคุณอาจจะเจอคนที่เข้ามาเติมเต็มความรู้สึก จากที่เคยรู้สึกโดดเดี่ยวเหงาเศร้า จะเจอความรักที่สุขเต็มเปี่ยม ชีวิตหวานสดชื่นแบบที่ไม่เคยสัมผัสมาก่อน ส่งผลให้คุณมีความมั่นใจมากยิ่งขึ้น ใครได้ไพ่ใบนี้ติดตัวไปมงลงแน่นอน"
  },
  {
    'cardid': 'C10',
    'cardnumber': 'C10',
    'image': require('@/assets/images/card/C10.jpg'),
    'name': 'Ten of Cups',
    'subtitle': 'ฟินจัง ปังปุริเย่',
    'detail': "ไพ่ใบนี้ต้องบอกเลยว่ารักปัง เปรียบดังความสุขความสดใสก็ว่าได้ คุณจะเจอคนที่เข้ามาดูแลกันได้ทุกวันแบบไม่แผ่วเลย ส่งผลให้ในแต่ละวันนั้นคุณมองเห็นอะไรก็เป็นสีชมพู นุ่มนวล บอกเลยว่าฟินกรุบไปเลยค่ะลูก ได้ไพ่นี้แล้วต้องโหลดเก็บอย่าให้ห่างตัว เชื่อแม่"
  },
  {
    'cardid': 'C11',
    'cardnumber': 'C11',
    'image': require('@/assets/images/card/C11.jpg'),
    'name': 'Page of Cups',
    'subtitle': 'ความรักดีๆ เริ่มที่รักตัวเอง',
    'detail': "ไพ่ใบนี้อาจทำให้คุณรู้สึกถึงความไม่แน่ใจ สับสนในความรัก จะรักใครชอบใครในช่วงนี้ก็ไม่ค่อยเวิร์คเพราะอารมณ์ของคุณไม่คงที่ ความรักที่เข้ามายังไม่ทันไรก็เหี่ยวเฉาเป็นอันแยกย้าย ถ้าอยากมีรักฟินๆ ก็ต้องปรับใจปรับความรู้สึกให้เฮลท์ตี้ ดูแลตัวเองให้ดูดี จะช่วยเสริมดวงให้พร้อมรับพลังงานดีๆ นะลูก"
  },
  {
    'cardid': 'C12',
    'cardnumber': 'C12',
    'image': require('@/assets/images/card/C12.jpg'),
    'name': 'Knight of Cups',
    'subtitle': 'ไม่ได้ตั้งใจชอบ แต่ตั้งใจรัก',
    'detail': "ไพ่บ่งบอกว่าคุณอาจเจอรักโรแมนติกจู่โจมเข้ามาแบบไม่ทันตั้งตัว และที่ฟินไปกว่านั้นก็คือ ถูกใจถูกสเป็กไปทุกอย่าง ทำให้คุณมีความสุขสุดๆ เหมือนได้ลิ้มลองรสชาติใหม่ๆ ที่ไม่เคยกิน ฟินมาก หรือใครที่คบกันมานานๆ จนไม่มีรสชาติ ความสัมพันธ์จะกลับมาหอมหวานอีกครั้ง"
  },
  {
    'cardid': 'C13',
    'cardnumber': 'C13',
    'image': require('@/assets/images/card/C13.jpg'),
    'name': 'Queen of Cups',
    'subtitle': 'ขึ้นบัลลังก์ออร่าพุ่ง',
    'detail': "ไพ่ใบนี้บอกเลยว่าคุณอาจเจอความรักที่ทำให้รู้สึกเป็นดั่งเจ้าหญิงในเทพนิยาย มีคนเข้ามาดูแลหัวใจจนใครๆ ก็อิจฉา และที่สำคัญคุณมีเกณฑ์พบรักจากการเดินทางเพราะคุณมีเสน่ห์โดดเด่น ใครอยู่ใกล้ก็อ่อนไหว ช่วงนี้บอกเลย สวยเลือกได้ จะเลือกแบบนุ่ม แบบแน่น แบบอร่อย เลือกที่ใช่แล้วกินเลยค่ะลูก"
  },
  {
    'cardid': 'C14',
    'cardnumber': 'C14',
    'image': require('@/assets/images/card/C14.jpg'),
    'name': 'King of Cups',
    'subtitle': 'เทคแคร์กันคือคำตอบ',
    'detail': "ไพ่ใบนี้บอกว่าคุณค่อนข้างควบคุมอารมณ์ได้ดี ถึงแม้จะเจอปัญหาความรักอยู่บ้าง แต่ก็จัดการกับปัญหาได้ดีมากๆ ปัญหาจะอยู่กับคุณไม่นาน หลังจากนั้นจะมีแต่ความฟิน กลับมาดูแลกันและกันเหมือนเดิม เชื่อแม่ แค่ไม่ปล่อยให้รักหมดโปร ช่วงโปรน่ะดีที่สุดแล้ว"
  },
  {
    'cardid': 'G01',
    'cardnumber': 'G1',
    'image': require('@/assets/images/card/G1.jpg'),
    'name': 'Page of Cups - Golden Card!',
    'subtitle': 'ความรักดีๆ เริ่มที่รักตัวเอง',
    'detail': "ไพ่ใบนี้อาจทำให้คุณรู้สึกถึงความไม่แน่ใจ สับสนในความรัก จะรักใครชอบใครในช่วงนี้ก็ไม่ค่อยเวิร์คเพราะอารมณ์ของคุณไม่คงที่ ความรักที่เข้ามายังไม่ทันไรก็เหี่ยวเฉาเป็นอันแยกย้าย ถ้าอยากมีรักฟินๆ ก็ต้องปรับใจปรับความรู้สึกให้เฮลท์ตี้ ดูแลตัวเองให้ดูดี จะช่วยเสริมดวงให้พร้อมรับพลังงานดีๆ นะลูก"
  },
  {
    'cardid': 'G02',
    'cardnumber': 'G2',
    'image': require('@/assets/images/card/G2.jpg'),
    'name': 'Knight of Cups - Golden Card!',
    'subtitle': 'ไม่ได้ตั้งใจชอบ แต่ตั้งใจรัก',
    'detail': "ไพ่บ่งบอกว่าคุณอาจเจอรักโรแมนติกจู่โจมเข้ามาแบบไม่ทันตั้งตัว และที่ฟินไปกว่านั้นก็คือ ถูกใจถูกสเป็กไปทุกอย่าง ทำให้คุณมีความสุขสุดๆ เหมือนได้ลิ้มลองรสชาติใหม่ๆ ที่ไม่เคยกิน ฟินมาก หรือใครที่คบกันมานานๆ จนไม่มีรสชาติ ความสัมพันธ์จะกลับมาหอมหวานอีกครั้ง"
  },
  {
    'cardid': 'G03',
    'cardnumber': 'G3',
    'image': require('@/assets/images/card/G3.jpg'),
    'name': 'Queen of Cups - Golden Card!',
    'subtitle': 'ขึ้นบัลลังก์ออร่าพุ่ง',
    'detail': "ไพ่ใบนี้บอกเลยว่าคุณอาจเจอความรักที่ทำให้รู้สึกเป็นดั่งเจ้าหญิงในเทพนิยาย มีคนเข้ามาดูแลหัวใจจนใครๆ ก็อิจฉา และที่สำคัญคุณมีเกณฑ์พบรักจากการเดินทางเพราะคุณมีเสน่ห์โดดเด่น ใครอยู่ใกล้ก็อ่อนไหว ช่วงนี้บอกเลย สวยเลือกได้ จะเลือกแบบนุ่ม แบบแน่น แบบอร่อย เลือกที่ใช่แล้วกินเลยค่ะลูก"
  },
  {
    'cardid': 'G04',
    'cardnumber': 'G4',
    'image': require('@/assets/images/card/G4.jpg'),
    'name': 'King of Cups - Golden Card!',
    'subtitle': 'เทคแคร์กันคือคำตอบ',
    'detail': "ไพ่ใบนี้บอกว่าคุณค่อนข้างควบคุมอารมณ์ได้ดี ถึงแม้จะเจอปัญหาความรักอยู่บ้าง แต่ก็จัดการกับปัญหาได้ดีมากๆ ปัญหาจะอยู่กับคุณไม่นาน หลังจากนั้นจะมีแต่ความฟิน กลับมาดูแลกันและกันเหมือนเดิม เชื่อแม่ แค่ไม่ปล่อยให้รักหมดโปร ช่วงโปรน่ะดีที่สุดแล้ว"
  },
]